export default "__VITE_ASSET__4xdh6vMH__"